module.exports = __webpack_public_path__ + "static/media/Calendar.69db9035.svg";